export enum ComponentsType {
  "vm-configuration" = 1,
  "post-provisioning-operations"=2,
  "policies"=3,
}